import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading } from "@cinch-labs/design-system";
import styles from "./store-hub-list.module.css";
import { ChevronRightIcon } from "../assets/chevron-right-icon";
import { LocationIcon } from "../assets/location-icon";
import { useViewport } from "@cinch-labs/shared-util";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
export const StoreCard = (store)=>{
    const { title , address , url  } = store;
    const { cached_url  } = url;
    const { vw  } = useViewport({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isMobile = vw < 1024;
    const cardCategory = "find a cinch store";
    const { trackEvent  } = useAnalytics();
    const slug = cached_url.split("/")[1];
    const handleClick = ()=>{
        trackEvent({
            eventName: `cinch stores hub - ${cardCategory}`,
            type: TrackingEventTypes.ADOBE,
            data: {
                action: "select",
                event: {
                    name: EventNames.click,
                    category: cardCategory,
                    label: slug
                }
            }
        });
        window.location.assign(`/${cached_url}`);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.cardWrapper,
        onClick: ()=>handleClick(),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.detailsSection,
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        element: "h3",
                        className: styles.subtitle,
                        children: title
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.addressLine,
                        children: [
                            !isMobile && /*#__PURE__*/ _jsx(LocationIcon, {}),
                            /*#__PURE__*/ _jsx("p", {
                                children: address
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.chevronIcon,
                children: /*#__PURE__*/ _jsx(ChevronRightIcon, {
                    size: vw < 768 ? "small" : "large"
                })
            })
        ]
    });
};
export const StoreHubList = ({ findStoreList  })=>{
    const { title , stores  } = findStoreList;
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.componentWrapper,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                element: "h2",
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.listWrapper,
                children: stores.map((store, index)=>/*#__PURE__*/ _jsx(StoreCard, {
                        ...store
                    }, `store-card-${index}`))
            })
        ]
    });
};
